export const styles = {
  card: {
    flex: 1,
    gap: 2.5,
    alignItems: "flex-start",
  },
  logoWrapper: {
    width: "120px",
    height: "120px",
    flexShrink: 0,
  },
  content: {
    gap: 2.5,
    textAlign: "left",
  },
  title: {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
